import { getAllRulesUrl } from './constants';

export async function manageRulesApi(
	api,
	method,
	payload,
	rule_id,
	setErrorApi,
	getRules,
	onSuccess
) {
	try {
		if (method === 'POST') {
			await api.post(`${getAllRulesUrl}to_many`, payload);
		} else if (method === 'DELETE') {
			await api.delete(`${getAllRulesUrl}${rule_id}`);
		}
		if (typeof getRules === 'function') {
			getRules();
		}
		if (typeof onSuccess === 'function') {
			onSuccess();
		}
	} catch (e) {
		if (typeof setErrorApi === 'function') {
			setErrorApi(
				e.response?.data?.detail || e.response?.data?.message || 'Неизвестная ошибка'
			);
		}
	}
}
